import React, { useState, useEffect } from "react";

const Create = ({
  socket,
  setInRoom,
  name,
  setName,
  roomId,
  setRoomId,
  gridSize,
  setGridSize,
}) => {
  const CreateHandle = () => {
    if (name.trim()) {
      if(gridSize==0){
        socket.emit("create_room", {name:name,gridSize:3});
      }else{
        socket.emit("create_room", {name:name,gridSize:gridSize});
      }

      socket.on("room_created", (data) => {
        setRoomId(data.roomId);
        setInRoom(true);
      });
      // console.log(gridSize)
    } else {
      alert("Please enter a name.");
    }
  };

  return (
    <div className="flex flex-col w-full h-full rounded-b-md">
      <h3 className="text-center text-theme-3 text-xl font-mono font-bold mb-6">
        Online Play
      </h3>
      <input
        type="text"
        className="m-1 h-10 pl-2 mb-2 placeholder-slate-600 bg-slate-100"
        placeholder="Enter your name:"
        value={name}
        onChange={(e) => {
          setName(e.target.value);
        }}
      />

      <select
        name="gridSize"
        className=" m-1 h-10 px-2 mb-2  font-semibold text-theme-2 bg-slate-100"
        onChange={(e) => {
          setGridSize(e.target.value);
        }}
      >
        <option value={0}>Grid Size</option>
        <option value={3}>3x3</option>
        <option value={4}>4x4</option>
        <option value={5}>5x5</option>
        <option value={6}>6x6</option>
      </select>

      <button
        onClick={CreateHandle}
        className="h-10 text-theme-4 font-bold hover:text-theme-3 bg-theme-2 m-1 px-2 text-lg py-1"
      >
        Create Room
      </button>
      <div>{roomId}</div>
    </div>
  );
};

export default Create;
